import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Root from './views/Root.vue'
import Result from './views/Result.vue'
import Profile from './views/Profile.vue'
import Details from './views/Details.vue'
import Favorites from './views/Favorites.vue'
import Faq from './views/Faq.vue'
import Rules from './views/Rules.vue'
import i18n from './i18n.js'
import store from './store.js'
import News from './views/News.vue'
import Admin from './views/Admin.vue'
import NewAd from './views/NewAd.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import Verification from './views/Verification.vue'
import VerificationDisplay from './views/VerificationDisplay.vue'
import Unsubscribe from './views/Unsubscribe.vue'
import EditAd from './views/EditAd3.vue'
import PageNotFound from './views/PageNotFound.vue'
import Competition from './views/Competition.vue'
import CompetitionEntry from './views/CompetitionEntry.vue'
import CompetitionEntryEdit from './views/CompetitionEntryEdit.vue'
import Competitions from './views/Competitions.vue'
import CompetitionRankList from './views/CompetitionRankList.vue'
import CompetitionRules from './views/CompetitionRules.vue'
import CompetitionNoSchool from './views/CompetitionNoSchool.vue'
import Franchise from './views/Franchise.vue'
import { api } from '@/api'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/' + i18n.locale
    },
    {
      path: '/:lang',
      name: 'Root',
      component: Root,
      children: [
        {
          path: '/:lang',
          name: 'Home',
          component: Home
        },
        {
          path: '/:lang/not-found',
          name: 'NotFound',
          component: PageNotFound
        },
        {
          path: '/:lang/about',
          name: 'About',
          component: About
        },
        {
          path: '/:lang/result',
          name: 'Result',
          component: Result
        },
        {
          path: '/:lang/details/:id',
          name: 'Details',
          component: Details
        },
        {
          path: '/:lang/editAd/:id',
          name: 'EditAd',
          meta: {
            sidRequired: true
          },
          component: EditAd
        },
        {
          path: '/:lang/favorites',
          name: 'Favorites',
          meta: {
            sidRequired: true
          },
          component: Favorites
        },
        {
          path: '/:lang/admin',
          name: 'Admin',
          meta: {
            adminRequired: true
          },
          component: Admin
        },
        {
          path: '/:lang/profile',
          name: 'Profile',
          meta: {
            sidRequired: true
          },
          component: Profile
        },
        {
          path: '/:lang/faq',
          name: 'Faq',
          component: Faq
        },
        {
          path: '/:lang/rules',
          name: 'Rules',
          component: Rules
        },
        {
          path: '/:lang/news',
          name: 'News',
          component: News
        },
        {
          path: '/:lang/newad',
          name: 'NewAd',
          meta: {
            sidRequired: true
          },
          component: NewAd
        },
        {
          path: '/:lang/forgot-password',
          name: 'ForgotPassword',
          component: ForgotPassword
        },
        {
          path: '/:lang/resend-verification',
          name: 'Verification',
          component: Verification
        },
        {
          path: '/:lang/verification',
          name: 'VerificationDisplay',
          component: VerificationDisplay
        },
        {
          path: '/:lang/unsubscribe',
          name: 'Unsubscribe',
          component: Unsubscribe
        },
        {
          path: '/:lang/competition/:id',
          name: 'Competition',
          component: Competition
        },
        {
          path: '/:lang/competition/:id/entry',
          name: 'CompetitionEntry',
          component: CompetitionEntry
        },
        {
          path: '/:lang/competition/:id/entry-edit',
          name: 'CompetitionEntryEdit',
          component: CompetitionEntryEdit
        },
        {
          path: '/:lang/competitions',
          name: 'Competitions',
          component: Competitions
        },
        {
          path: '/:lang/competition-rules/:id',
          name: 'CompetitionRules',
          component: CompetitionRules
        },
        {
          path: '/:lang/competition-rank-list/:id',
          name: 'CompetitionRankList',
          component: CompetitionRankList
        },
        {
          path: '/:lang/competitions/missing-school-link',
          name: 'CompetitionNoSchool',
          component: CompetitionNoSchool
        },
        {
          path: '/:lang/franchise',
          name: 'Franchise',
          component: Franchise
        }
      ]
    },
    {
      path: '*',
      redirect: `/${i18n.locale}/not-found`
    }
  ]
})

router.afterEach((to, from) => {
  if (to.params.lang) {
    i18n.locale = to.params.lang
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.adminRequired) {
    api
      .checkSession()
      .then(res => {
        store.commit('changeUserIsLoged', true)
        store.commit('setUserName', res.data.usr_name)
        if (res.data.admin && res.data.admin === true) {
          store.commit('setUserAdmin', true)
        }
        api
          .getNotificationsCount()
          .then(r => {
            store.commit('setNotificationCounters', r.data)
          })
          .catch(e => {
            console.log(e)
          })
      })
      .catch(e => {
        if (e.response.request.status === 401) {
          store.commit('changeUserIsLoged', false)
          store.commit('setUserName', null)
          store.commit('setUserAdmin', false)
          return next('/' + i18n.locale)
        }
      })
      .finally(() => {
        if (localStorage.sid && store.state.userAdmin) {
          return next()
        } else {
          return next('/' + i18n.locale)
        }
      })
  } else if (to.meta.sidRequired) {
    api
      .checkSession()
      .then(res => {
        store.commit('changeUserIsLoged', true)
        store.commit('setUserName', res.data.usr_name)
        if (res.data.admin && res.data.admin === true) {
          store.commit('setUserAdmin', true)
        }
        api
          .getNotificationsCount()
          .then(r => {
            store.commit('setNotificationCounters', r.data)
          })
          .catch(e => {
            console.log(e)
          })
      })
      .catch(e => {
        if (e.response.request.status === 401) {
          store.commit('changeUserIsLoged', false)
          store.commit('setUserName', null)
          store.commit('setUserAdmin', false)
          return next('/' + i18n.locale)
        }
      })
      .finally(() => {
        if (localStorage.sid && store.state.userIsLoged) {
          return next()
        } else {
          return next('/' + i18n.locale)
        }
      })
  } else {
    return next()
  }
})

export default router
